// extracted by mini-css-extract-plugin
module.exports = {"table":"actions-history-modal_table__UGDvj","container":"actions-history-modal_container__ydfYX","modal":"actions-history-modal_modal__Gsilh"};